import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, password, fullName);
      navigate("/");
    } catch (err) {
      setError(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] grid-bg flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-2 h-2 bg-[#00E676] pulse" />
          <span className="mono text-[14px] tracking-[0.22em] font-bold">ALPAC/X</span>
        </div>
        <h1 className="text-4xl font-black tracking-tight mb-1">Create account</h1>
        <p className="text-[#A1A1AA] text-sm mb-8">Set up your trader profile in seconds.</p>

        <form onSubmit={onSubmit} className="space-y-3" data-testid="register-form">
          <div>
            <label className="mono text-[10px] tracking-[0.2em] text-[#71717A]">FULL NAME (OPTIONAL)</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              data-testid="register-name-input"
              className="mt-1 w-full bg-[#141415] border border-[#27272A] focus:border-[#52525B] px-3 py-2.5 text-white text-sm"
              placeholder="Jane Doe"
            />
          </div>
          <div>
            <label className="mono text-[10px] tracking-[0.2em] text-[#71717A]">EMAIL</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="register-email-input"
              className="mt-1 w-full bg-[#141415] border border-[#27272A] focus:border-[#52525B] px-3 py-2.5 text-white text-sm"
            />
          </div>
          <div>
            <label className="mono text-[10px] tracking-[0.2em] text-[#71717A]">PASSWORD (MIN 6)</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="register-password-input"
              className="mt-1 w-full bg-[#141415] border border-[#27272A] focus:border-[#52525B] px-3 py-2.5 text-white text-sm"
            />
          </div>
          {error && <div className="text-[#FF3B30] mono text-xs" data-testid="register-error">{error}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit-button"
            className="w-full bg-white text-black py-2.5 mono text-xs tracking-[0.22em] font-bold hover:bg-[#D4D4D8] disabled:opacity-50"
          >
            {loading ? "CREATING..." : "CREATE ACCOUNT →"}
          </button>
        </form>

        <div className="mt-6 text-xs text-[#71717A]">
          Already a trader?{" "}
          <Link to="/login" className="text-white hover:text-[#00E676]">
            Sign in →
          </Link>
        </div>
      </div>
    </div>
  );
}
